// extracted by mini-css-extract-plugin
module.exports = {"section":"ButtonsEdit_section__3Yqx2","previewContainer":"ButtonsEdit_previewContainer__RFxjh"};